import { render } from "./Pricing.vue?vue&type=template&id=146f2e7e&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=146f2e7e&scoped=true&lang=css"

import exportComponent from "/Users/ratitsiklauri/DevProjects/DK-Projects/recturing-front-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146f2e7e"]])

export default __exports__